import { z } from "zod";
import { TObjectBase } from "../../base";
import { TApiCustomField } from "../../customFields/customFields";
import { TReadAccess } from "../../common/readAccess";
import { TTranslationData } from "../../common/translation";
import { TCollectionItemAgreementFields } from "./customItemFields";

export const TRawCollectionItemFieldSchema = z.object({
  value: z.any().optional(),
});

export type IRawPropertyCollectionItem = z.infer<
  typeof TRawPropertyCollectionItem
>;
export const TRawPropertyCollectionItem = z
  .object({
    name: z.string(),
    fields: z.record(TRawCollectionItemFieldSchema).optional(),
    readAccess: TReadAccess.optional(),
    folderID: z.string().nullish(),
    propertyFileIDs: z.array(z.string()).optional(),
    fileIDs: z.array(z.string()).optional(),
    writeAccess: TReadAccess.optional(),

    agreementFields: TCollectionItemAgreementFields.optional(),
  })
  .extend(TObjectBase.shape);

const TRawCollectionConnection = z.object({
  deviations: z.boolean().optional(),
  propertyFiles: z.boolean().optional(),
  routines: z.boolean().optional(),
});

export type IRawPropertyCollection = z.infer<typeof TRawPropertyCollection>;
export const TRawPropertyCollection = z
  .object({
    connections: TRawCollectionConnection.optional(),
    itemCount: z.number().optional(),
    name: TTranslationData,
    previewFields: z.array(z.string()).optional(),
    readAccess: TReadAccess.optional(),
    requiredWriteAccess: TReadAccess.optional(),
    standardLangCode: z.string().optional(),

    customFieldsOrder: z.array(z.string()).default([]),
  })
  .extend(TObjectBase.shape);

export type IPropertyCollection = z.infer<typeof TPropertyCollection>;
export const TPropertyCollection = z
  .object({
    customFields: z.optional(z.lazy(() => z.array(TApiCustomField))),
    items: z.optional(z.lazy(() => z.array(TRawPropertyCollectionItem))),
    previewFields: z.optional(z.array(z.string())),

    name: z.record(
      z.object({
        default: z.string(),
      })
    ),
    standardLangCode: z.string().optional(),
  })
  .extend(TObjectBase.shape);

export const TRawPropertyCollectionItemRoutine = z
  .object({
    /** @deprecated Load from /routines/:id instead */
    title: z.string().optional(),
    /** @deprecated Load from /routines/:id instead */
    active: z.boolean().optional(),
  })
  .extend(TObjectBase.shape);
export type IRawPropertyCollectionItemRoutine = z.infer<
  typeof TRawPropertyCollectionItemRoutine
>;

export const TRawPropertyCollectionItemDeviation = z
  .object({
    deviationID: z.string(),
    propertyID: z.string(),
  })
  .extend(TObjectBase.shape);
export type IRawPropertyCollectionItemDeviation = z.infer<
  typeof TRawPropertyCollectionItemDeviation
>;
